import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation';
import { ROUTES } from '../Routes';
import { usePageTitle } from '../hooks/usePageTitle';

const AboutUsPage = () => {
    usePageTitle('Elder House');
    return (
        <div className='wp-singular page-template-default page page-id-7 wp-theme-ppc2'>
            <Navigation />
            <main id="main">
                <div className="container">

                    <section className="hero about-hero">
                        <div className="kicker">THE ARCHIVE • VIRTUAL-ONLY LEDGER</div>

                        <h1 className="hero-title">
                            Elder House of <span className="hero-title__name">Talox Games</span>
                        </h1>

                        <p className="hero-lead">
                            Our house is a curated social experience 🗝️: all play is powered by virtual Credits, never by
                            deposits or withdrawals. There is no real-money value — only the thrill of discovery and the
                            beauty of the halls.
                        </p>

                        <div className="hero-actions">
                            <Link to={ROUTES.REGISTER} className="play-btn">
                                CLAIM STARTER CREDITS
                            </Link>
                            <a href="#story" className="play-btn alt">READ THE CHRONICLE</a>
                        </div>
                    </section>

                    <section className="content-section" id="story">
                        <h2>The Chronicle of the House</h2>

                        <div className="card" style={{marginTop: "1.2rem"}}>
                            <div className="tag">01 / THE RITUAL</div>
                            <h3>Choose. Wager. Reveal.</h3>
                            <p className="page-copy">
                                Each visit is a ritual: select a wing, spend virtual Credits, reveal the outcome, and let the
                                house record your path. Your ledger updates instantly and your progress is preserved.
                            </p>
                            <p className="mini">
                                Everything here is virtual-only — no deposits, no withdrawals, no cash value.
                            </p>
                        </div>

                        <div className="card" style={{marginTop: "1.1rem"}}>
                            <div className="tag">02 / THE HOUSE RULES</div>
                            <h3>What keeps the halls alive</h3>

                            <div className="grid-tiles" style={{marginTop: "1rem"}}>
                                <div className="tile">
                                    <h4>Starter Credits</h4>
                                    <p className="mini">Begin with a balanced grant to explore the mansion’s chambers.</p>
                                </div>
                                <div className="tile">
                                    <h4>Refill Cycles</h4>
                                    <p className="mini">Credits replenish over time without payments or purchases.</p>
                                </div>
                                <div className="tile">
                                    <h4>Session Ledger</h4>
                                    <p className="mini">Track your outcomes and return to your story at any time.</p>
                                </div>
                                <div className="tile">
                                    <h4>Community Echo</h4>
                                    <p className="mini">See how others fare, celebrate mastery, and stay inspired.</p>
                                </div>
                            </div>
                        </div>

                        <div className="card" style={{marginTop: "1.1rem"}}>
                            <div className="tag">03 / THE OATH</div>
                            <h3>Responsible play in the moonlight</h3>
                            <p className="page-copy">
                                The Elder House is designed for calm, mindful entertainment. Take breaks, keep play light,
                                and remember the house is a stage for virtual-only stories.
                            </p>
                            <ul className="list">
                                <li>All Credits are virtual with no real-world value.</li>
                                <li>No deposits, purchases, or top-ups are available.</li>
                                <li>No withdrawals or rewards of any kind are offered.</li>
                                <li>Entry is restricted to 18+ guests only.</li>
                                <li>Each chamber lists its own rules and pacing.</li>
                            </ul>
                        </div>

                        <div className="card" style={{marginTop: "1.1rem"}}>
                            <div className="tag">04 / THE SIGNAL</div>
                            <h3>Speak with the caretakers</h3>
                            <p className="page-copy">
                                We welcome feedback, bug reports, and thoughtful collaborations. Send a signal and the house
                                will answer.
                            </p>

                            <div className="grid-tiles" style={{marginTop: "1rem"}}>
                                <div className="tile">
                                    <h4>Email</h4>
                                    <p className="mini"><a href="/cdn-cgi/l/email-protection" className="__cf_email__"
                                        data-cfemail="dab3b4bcb59abebba8b1b7bbb4a9b3b5b4bdbbb7bfa9f4b9b5b7">info@Talox.site</a>
                                    </p>
                                </div>
                                <div className="tile">
                                    <h4>Website</h4>
                                    <p className="mini">https://Talox.site</p>
                                </div>
                            </div>
                        </div>

                        <div style={{textAlign: "center", margin: "2.2rem 0 1.6rem"}}>
                            <h3>Keep your candle lit</h3>
                            <p className="mini" style={{maxWidth: "760px", margin: ".6rem auto 1.2rem"}}>
                                Step back into the halls whenever the mood strikes. The house remembers your story.
                            </p>
                            <div className="hero-actions" style={{justifyContent: "center"}}>
                                <Link to={ROUTES.REGISTER} className="play-btn">
                                    CLAIM STARTER CREDITS
                                </Link>
                                <Link to="/" className="play-btn alt">BACK TO HOME</Link>
                            </div>
                        </div>

                    </section>

                </div>
            </main>
            <Footer />
        </div>
    )
}

export default AboutUsPage